// extracted by mini-css-extract-plugin
export default {"navbarCentered":"Navbar_navbarCentered__dUvxb"};